/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Bar Singleton
 */

export default class ButterBarManager {
  constructor() {
    this.bbId = 0
    this.onGoingTimeouts = {}
  }

  getUniqueId() {
    this.bbId += 1
    return this.bbId
  }

  startTimeout(butterBar) {
    if (butterBar && !this.onGoingTimeouts[butterBar.bbId] && !butterBar.persistent) {
      this.onGoingTimeouts[butterBar.bbId] = setTimeout(butterBar.removeHandler, butterBar.duration)
    }
  }

  cancelTimeout(butterBar) {
    if (butterBar && this.onGoingTimeouts[butterBar.bbId]) {
      clearTimeout(this.onGoingTimeouts[butterBar.bbId])
      delete this.onGoingTimeouts[butterBar.bbId]
    }
  }
}
